export default __webpack_public_path__ + "static/media/hall2.edbc2bd9.png";